export default [
  { title: 'Planning', route: 'planning', icon: 'CalendarIcon' },
  { title: 'Jeunes', route: 'youngs', icon: 'UsersIcon' },
  { title: 'Statistiques', route: 'statistics', icon: 'BarChart2Icon' },
]
